import { render, staticRenderFns } from "./vehicleCard.vue?vue&type=template&id=172dbea6&scoped=true&"
import script from "./vehicleCard.vue?vue&type=script&lang=js&"
export * from "./vehicleCard.vue?vue&type=script&lang=js&"
import style0 from "./vehicleCard.vue?vue&type=style&index=0&id=172dbea6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172dbea6",
  null
  
)

export default component.exports